import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { catchError, first, tap } from 'rxjs/operators';
import {Client, ClientUserOutput} from '../models/client.model';
import { Module } from '../models/module.model';
import { Office } from '../models/office.model';
import { Restrictions } from '../models/restrictions.model';
import { RestService } from './rest.service';
import { NotificationService } from '../shared/services/notification.service';

@Injectable({
  providedIn: 'root',
})
export class ClientsService {
  constructor(
    private rest: RestService,
    private notificationService: NotificationService
  ) {}

  getMyModules(): Observable<Module[]>{
    return this.rest.get$<Module[]>('my/modules', true, 'client');
  }
  getClientInfo(): Observable<ClientUserOutput> {
    return this.rest.get$<ClientUserOutput>(`user/my`, true, 'client').pipe(first());
  }

  setMyLogo(selectedFile: File): Observable<{ url: string }> {
    const fd = new FormData();
    fd.append('logo', selectedFile, selectedFile.name);
    return this.rest.post$<{ url: string }>('my/logo', fd, true, 'client');
  }

  setMyPdfAwardsFile(selectedFile: File): Observable<{ url: string }> {
    const fd = new FormData();
    fd.append('awards_regulation', selectedFile, selectedFile.name);
    return this.rest.post$<{ url: string }>(
      'my/awards-regulation',
      fd,
      true,
      'client'
    );
  }

  saveRestrictions(restrictions: Restrictions): Observable<string> {
    return this.rest
      .putEmptyResponse$(`my`, { restrictions: restrictions }, 'client')
      .pipe(
        first(),
        tap((_) => {
          this.notificationService.showSuccess('Restrizioni aggiornate!');
        })
      );
  }

  contactEmailChanged(email: string): Observable<string> {
    return this.rest.putEmptyResponse$(`my`, { email }, 'client').pipe(
      catchError((err) => {
        console.error(err);
        throw err;
      })
    );
  }

  // Offfices
  // deleteOffice(officeId: string): Observable<string> {
  //   return this.rest
  //     .putEmptyResponse$(`my/office/remove`, { office_id: officeId }, 'client')
  //     .pipe(first());
  // }
  //
  // updateOffice(office: Office): Observable<Office> {
  //   return this.rest
  //     .put$<Office>(`my/office/update`, office, 'client')
  //     .pipe(first());
  // }
  //
  // addOffice(office: Omit<Office, 'id'>): Observable<Office> {
  //   return this.rest.put$<Office>(`my/office/add`, office, 'client').pipe(
  //     first(),
  //     catchError((err) => {
  //       this.notificationService.showError(err.message);
  //       throw err;
  //     })
  //   );
  // }
  // // Offices
  //
  // saveWorKShift(
  //   workShift: Pick<Client, 'chosen_array_time' | 'chosen_array_week_day'>
  // ): Observable<string> {
  //   return this.rest.putEmptyResponse$(`my`, workShift, 'client').pipe(first());
  // }
}
